import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import Budget from '../../../widgets/budget/Budget'
import { useParams, useHistory } from 'react-router-dom'
import { getPaymentCheck, savePaymentCheckForceCommit } from '../../../redux/actions/paymentCheck'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import pathname from '../../../constants/pathname'
import ProjectDataTable from '../../../widgets/dataTable/ProjectDataTable'
import { Button, Col, Message, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import {
  getMultiProjectReviewPaymentCheckPage,
  getMultiReviewPaymentCheckProjectList,
  saveMultiReviewPaymentCheck,
} from '../../../redux/actions/multiReview'
import ConfirmWidget from '../../../widgets/confirm/ConfirmWidget'

export default function PaymentCheckMulti() {
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [confirmForceSchema, setConfirmForceSchema] = useState()
  const [confirmSubmitAll, setConfirmSubmitAll] = useState()

  const [isReLoading, setIsReLoading] = useState(false)
  const [proposalBudget, setProposalBudget] = useState()
  const [section, setSection] = useState()
  const [dataTableSection, setDataTableSection] = useState()
  const [singleProject, setSingleProject] = useState()
  const [singleError, setSingleError] = useState()
  const [summitAllError, setSummitAllError] = useState()
  const [projectList, setProjectList] = useState()
  // const [isEditBudgetPlan, setIsEditBudgetPlan] = useState(false)

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectId) => {
    setIsLoading(true)
    startLoading()
    try {
      setProposalBudget('')
      setSingleProject('')
      const _schema = await getMultiProjectReviewPaymentCheckPage(projectId)
      // console.log('handleGetSchema response', _schema)
      // const _schema = mock
      setSchema(_schema)
      setProjectList(_schema?.forms?.projectList)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleReload = async (pagesize, pagenumber) => {
    setIsReLoading(true)
    startLoading()
    try {
      setProposalBudget('')
      setSingleProject('')
      const response = await getMultiReviewPaymentCheckProjectList(projectId, pagesize, pagenumber)
      setProjectList(response)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsReLoading(false)
  }

  const onSingleSubmit = async (obj) => {
    console.log('obj', obj)
    setSingleError(false)
    startLoading()
    try {
      setProposalBudget('')
      setSingleProject(obj)
      const response = await getPaymentCheck(obj.id)
      //console.log('response', response)

      let _schema = response

      if (_schema) {
        _schema['header'] = obj.projectName
        setProposalBudget(_schema)
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      }

      console.log('_schema', _schema)
    } catch (e) {
      console.log('e', e)
      setSingleError(true)
    }

    doneLoading()
  }

  const onSubmitAllPaymentCheck = async () => {
    setIsLoading(true)
    setConfirmSubmitAll(false)
    setSummitAllError('')
    startLoading()
    try {
      setProposalBudget('')
      setSingleProject('')
      let request = {
        groupId: projectId,
      }
      const response = await saveMultiReviewPaymentCheck(request)
      console.log('response', response)
      setSchema(response)
      setProjectList(response?.forms?.projectList)
    } catch (e) {
      console.log('e', e)
      setSummitAllError('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
    }
    doneLoading()

    setIsLoading(false)
  }

  const handleConfirmBudget = async (
    _setIsLoading,
    _setErrorMessage,
    _setIsShowConfirmForce,
    forceCommit = false
  ) => {
    startLoading()
    _setIsLoading(true)
    _setErrorMessage()
    try {
      var response = await savePaymentCheckForceCommit(projectId, forceCommit)
      if (response.isSuccess) {
        doneLoading()
        return history.push(`${pathname.proposal.approve.granteeForStaff}`)
      } else if (!response.isSuccess && response.confirm) {
        setConfirmForceSchema(response.confirm)
        _setIsShowConfirmForce(true)
        _setErrorMessage(response?.message)
      } else {
        _setErrorMessage(response?.message)
      }
    } catch (e) {
      console.log(e)
      _setErrorMessage(
        e.response?.data?.errorMessage ||
          'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
      )
    }
    _setIsLoading(false)
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal isMultiReview>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiReview>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiReview>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      {/* บล็อกหลายโครงการ */}
      {schema?.forms?.paymentCheckAll && (
        <>
          {summitAllError && (
            <Message
              showIcon
              type="error"
              description={summitAllError}
              style={{ marginBottom: 10 }}
            />
          )}
          {schema?.forms?.saveResult?.success && (
            <Message
              showIcon
              type="info"
              description={`${schema.forms.saveResult.success.label} : ${schema.forms.saveResult.success.value} `}
              style={{ marginBottom: 10 }}
            />
          )}
          {schema?.forms?.saveResult?.error && (
            <Message
              showIcon
              type="warning"
              description={`${schema.forms.saveResult.error.label} : ${schema.forms.saveResult.error.value} `}
              style={{ marginBottom: 10 }}
            />
          )}
          {schema.forms.paymentCheckAll.message && (
            <Message
              showIcon
              type="warning"
              description={`${schema.forms.paymentCheckAll.message}`}
              style={{ marginBottom: 10 }}
            />
          )}
          <Button
            // style={{ width: 160 }}
            // appearance="ghost"
            color="rgb(45, 168, 136)"
            appearance="primary"
            onClick={() => {
              setConfirmSubmitAll(true)
            }}
            disabled={isLoading || schema.forms.paymentCheckAll.isDisabled}
            style={{ marginBottom: 10 }}
          >
            {schema.forms.paymentCheckAll.buttonText}
          </Button>
        </>
      )}

      <Row
        ref={(section) => {
          setDataTableSection(section)
        }}
      ></Row>

      {projectList && (
        <>
          <ProjectDataTable
            schema={projectList}
            single={{
              enable: true,
              buttonText: projectList.buttonText || 'ตรวจสอบยืนยันงบประมาณ',
              iconByStatus: true,
              hideText: false,
              width: 210,
            }}
            onSingleSubmit={onSingleSubmit}
            pagination={true}
            onReload={handleReload}
            loading={isReLoading}
          />
          <br />
        </>
      )}

      <Row
        ref={(section) => {
          setSection(section)
        }}
      >
        {singleError && (
          <>
            <Message
              showIcon
              type="error"
              description={`ดึงข้อมูลโครงการ ${singleProject?.projectName} ไม่สำเร็จ`}
            />
            <br />
          </>
        )}
      </Row>

      {proposalBudget && (
        <>
          <Panel
            header={
              <div>
                <Col xs={20} sm={20} md={20} lg={20}>
                  {proposalBudget.header}
                </Col>
                <Col xs={4} sm={4} md={4} lg={4} align="right">
                  <CancelButton
                    onClick={() => {
                      setProposalBudget('')
                    }}
                  >{`ปิด`}</CancelButton>
                </Col>
              </div>
            }
            bordered
            collapsible
            defaultExpanded
            shaded
            style={{ marginBottom: 20 }}
          >
            <ProjectBasicInfo schema={proposalBudget?.forms?.projectInfo} shaded={false} />

            <br />

            <Budget
              schema={proposalBudget?.forms}
              isEditable={false}
              defaultExpandAllRows={true}
              isShowBudgetSubmitButton={true}
              onClickConfirmBudget={handleConfirmBudget}
              confirmForceSchema={confirmForceSchema}
              shaded={false}
              bordered={false}
            />
            <br />
          </Panel>
        </>
      )}

      <ConfirmWidget
        title={'ยืนยัน'}
        show={confirmSubmitAll}
        detail={`ยืนยันงบประมาณไปยังทุกโครงการ`}
        onCancle={() => setConfirmSubmitAll(false)}
        onConfirm={onSubmitAllPaymentCheck}
      />
    </SidebarProposal>
  )
}
